import { cn } from "@/lib/utils";
import { AlertTriangle, Info, CheckCircle } from "lucide-react";
import GlassCard from "@/components/GlassCard";

const ActionCard = ({ title, dueText, urgency, className, actionButton }) => {
    const getUrgencyStyles = (urgency) => {
        switch (urgency) {
            case "high":
                return {
                    icon: AlertTriangle,
                    iconColor: "text-destructive",
                    bgColor: "bg-destructive/10",
                    borderClass: "border-l-4 border-l-destructive",
                };
            case "medium":
                return {
                    icon: Info,
                    iconColor: "text-amber-500",
                    bgColor: "bg-amber-500/10",
                    borderClass: "",
                };
            default:
                return {
                    icon: CheckCircle,
                    iconColor: "text-emerald-500",
                    bgColor: "bg-emerald-500/10",
                    borderClass: "",
                };
        }
    };

    const styles = getUrgencyStyles(urgency);
    const Icon = styles.icon;

    return (
        <GlassCard className={cn("p-4", styles.borderClass, className)}>
            <div className="flex items-start gap-3">
                <div className={cn("p-2 rounded-xl", styles.bgColor)}>
                    <Icon className={cn("w-5 h-5", styles.iconColor)} />
                </div>
                <div className="flex-1 min-w-0 pr-2 flex justify-between items-center">
                    <div className="min-w-0">
                        <h3 className="font-medium text-foreground pr-2">{title}</h3>
                        <p className="text-sm text-muted-foreground mt-0.5">{dueText}</p>
                    </div>
                    {actionButton && (
                        <div className="ml-2 flex-shrink-0 relative z-10" onClick={(e) => e.stopPropagation()}>
                            {actionButton}
                        </div>
                    )}
                </div>
            </div>
        </GlassCard>
    );
};

export default ActionCard;
